export default __webpack_public_path__ + "static/media/v4.bb27b96f.jpg";